import { Box, Button, Icon, Text } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { selectIsSourceOfFundsVisible } from '../../state';
import { useSelector } from '@bonanza-social/toolkit/state';

function SOFCard() {
  const isSourceOfFundsVisible = useSelector(selectIsSourceOfFundsVisible);
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleFillFormNavigation = () => {
    navigation.navigate('SOFAttestation');
  };

  if (!isSourceOfFundsVisible) {
    return null;
  }

  return (
    <Box
      padding="space-400"
      gap="space-200"
      borderColor="borderGoldSolid"
      borderWidth="border-width-025"
      borderRadius="radius-200"
    >
      <Box flexDirection="row" alignItems="center" gap="space-100">
        <Icon
          name="info"
          width="space-600"
          height="space-600"
          color="darkSurfacePrimary"
        />
        <Text
          variant="body-s-semi"
          color="darkSurfaceTertiary"
          locKey="SOFWeNeedYourHelp"
          locNS="account"
        />
      </Box>
      <Text
        variant="caption"
        color="darkSurfaceMuted"
        locKey="SOFInformationIsRequired"
        locNS="account"
      />
      <Button
        variant="primary"
        locKey="SOFFillForm"
        locNS="account"
        onPress={handleFillFormNavigation}
        maxWidth="40%"
        marginTop="space-200"
      />
    </Box>
  );
}

export default SOFCard;
